module.exports = __webpack_public_path__ + "static/media/option-red.05625175.png";